import React, { Component } from 'react';
import { scorableDocks } from '../../../../Game/GamePlayerInfo';
import { getTextureUrl } from '../../../Common/TextureTools';


class SnoheIcon extends Component {
    render() {
        return <img
            src={getTextureUrl(129)}
            alt="snohe"
            style={{ width: '200px' }}
        />;
    }
}


export default class ScoreChoice extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
    }

    clickDock = (dockId) => {
        this.api.clickScoreDock(dockId);
    }

    componentDidMount() {
        this.highlightDockChoices();
        window.addEventListener(
            'hotel-interface-mounted-event', this.mountedEvent);
    }

    mountedEvent = () => {
        this.highlightDockChoices();
    }

    highlightDockChoices = () => {
        window.dispatchEvent(
            new CustomEvent('highlight-docks-event',
                {
                    detail: {
                        highlightedDocks: scorableDocks(this.props.gamePlayerData),
                        callback: this.clickDock
                    }
                }));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        window.dispatchEvent(
            new CustomEvent('highlight-docks-event',
                {
                    detail: {
                        highlightedDocks: scorableDocks(this.props.gamePlayerData),
                        callback: this.clickDock
                    }
                }));
    }

    componentWillUnmount() {
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
        window.removeEventListener(
            'hotel-interface-mounted-event', this.mountedEvent);
    }

    render() {
        return <></>;
    }
}
